import { render, staticRenderFns } from "./logo.vue?vue&type=template&id=adf1c502"
import script from "./logo.vue?vue&type=script&lang=js"
export * from "./logo.vue?vue&type=script&lang=js"
import style0 from "./logo.vue?vue&type=style&index=0&id=adf1c502&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('adf1c502')) {
      api.createRecord('adf1c502', component.options)
    } else {
      api.reload('adf1c502', component.options)
    }
    module.hot.accept("./logo.vue?vue&type=template&id=adf1c502", function () {
      api.rerender('adf1c502', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/page/index/logo.vue"
export default component.exports